import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './category-breakdown-chips.scss'

export interface CategoryBreakdownEntry {
  label: string
  count: number
  icon?: IconDefinition
}

export interface CategoryBreakdownChipsProps {
  entries: CategoryBreakdownEntry[]
}

/** Faixa de chips mostrando a contagem por categoria sobre um conjunto de
 *  eventos já filtrado — "desses N resultados, quantos são X/Y/Z". */
const CategoryBreakdownChips: React.FC<CategoryBreakdownChipsProps> = ({ entries }) => {
  if (entries.length === 0) {
    return null
  }

  return (
    <div className='category-breakdown-chips'>
      {entries.map((entry) => (
        <span
          key={entry.label}
          className='category-breakdown-chip'
        >
          {entry.icon && (
            <FontAwesomeIcon
              icon={entry.icon}
              className='category-breakdown-chip__icon'
            />
          )}
          <span className='category-breakdown-chip__label'>{entry.label}:</span>
          <span className='category-breakdown-chip__count'>{entry.count}</span>
        </span>
      ))}
    </div>
  )
}

export default CategoryBreakdownChips
